import { createContext, useEffect, useReducer } from "react";

const initial_state = {
  user: null,
  loading: false,
  error: null,
};

export const AuthContext = createContext(initial_state);

const normalizeUser = (rawUser) => {
  if (!rawUser) return null;
  if (rawUser.user) return normalizeUser(rawUser.user);
  if (rawUser.data) return normalizeUser(rawUser.data);
  if (Array.isArray(rawUser) && rawUser.length === 1) return normalizeUser(rawUser[0]);
  return rawUser._doc ?? rawUser;
};

const AuthReducer = (state, action) => {
  switch (action.type) {
    case "LOGIN_START":
      return { ...state, loading: true, error: null };
    case "LOGIN_SUCCESS":
      return { ...state, user: normalizeUser(action.payload), loading: false, error: null };
    case "LOGIN_FAILURE":
      return { ...state, user: null, loading: false, error: action.payload };
    case "LOGOUT":
      return { ...state, user: null, loading: false, error: null };
    default:
      return state;
  }
};

export const AuthContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(AuthReducer, initial_state);

  useEffect(() => {
    const savedUser = localStorage.getItem("user");
    if (!savedUser) return;
    try {
      const parsedUser = JSON.parse(savedUser);
      dispatch({ type: "LOGIN_SUCCESS", payload: parsedUser });
    } catch (err) {
      localStorage.removeItem("user");
    }
  }, []);

  useEffect(() => {
    if (state.user) {
      localStorage.setItem("user", JSON.stringify(state.user));
    } else {
      localStorage.removeItem("user");
    }
  }, [state.user]);

  // Intercept LOGIN_SUCCESS to remove token from response (now stored in HTTPOnly cookie)
  const customDispatch = (action) => {
    if (action.type === "LOGOUT") {
      localStorage.removeItem("user");
    }
    dispatch(action);
  };

  return (
    <AuthContext.Provider
      value={{
        user: state.user,
        loading: state.loading,
        error: state.error,
        dispatch: customDispatch,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};